import React, { useLayoutEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "./components/navbar/Navbar";
import Hero from "./components/hero/Hero";
import Skills from "./components/skills/Skills";
import Experience from "./components/experience/Experience";
import HireMe from "./components/hireme/HireMe";
import Footer from "./components/footer/Footer";

function App() {
  // Scroll to hero section on initial load
  useLayoutEffect(() => {
    setTimeout(() => {
      const el = document.getElementById("hero");
      if (el) {
        el.scrollIntoView({ behavior: "auto" });
      }
    }, 50);
  }, []);

  return (
    <Box>
      <Navbar />
      <Box className="padding">
        <Box
          component="section"
          id="hero"
          sx={{ scrollMarginTop: { xs: 60, md: 70 } }}
        >
          <Hero />
        </Box>
        <Box
          component="section"
          id="skills"
          sx={{ scrollMarginTop: { xs: 60, md: 70 } }}
        >
          <Skills />
        </Box>
        <Box
          component="section"
          id="experience"
          sx={{ scrollMarginTop: { xs: 60, md: 70 } }}
        >
          <Experience />
        </Box>
        <Box
          component="section"
          id="hire"
          sx={{ scrollMarginTop: { xs: 60, md: 65 } }}
        >
          <HireMe />
        </Box>
        <Footer />
      </Box>
    </Box>
  );
}

export default App;
